export const formatPhoneNumber = (phoneNumberString: string | undefined, includeCountryCode: boolean = false) => {
  if (!phoneNumberString) {
    return null;
  }
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return includeCountryCode
      ? '+1 (' + match[1] + ') ' + match[2] + '-' + match[3]
      : '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
};
